import { render, staticRenderFns } from "./DatabaseEditTab.vue?vue&type=template&id=ee06219c&"
import script from "./DatabaseEditTab.vue?vue&type=script&lang=js&"
export * from "./DatabaseEditTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports